<template>
  <with-invoice :invoice-id="invoiceId">
    <template slot="default" slot-scope="{invoice}">
      <v-layout>
        <v-flex xs1>Status:</v-flex>
        <v-flex xs1>
          <v-menu full-width offset-y :close-on-content-click="false" v-model="changeFormsVisible" bottom>
            <b slot="activator">
              {{invoice.status}}
            </b>

            <div v-if="isMarkAsDraftAvailable(invoice)">
              <mark-invoice-as-draft-form :invoice="invoice"/>
            </div>
            <div v-if="isMarkAsCheckedAvailable(invoice)">
              <mark-invoice-as-checked-form :invoice="invoice"/>
            </div>
            <div v-if="isMarkAsChargedAvailable(invoice)">
              <mark-invoice-as-charged-form :invoice="invoice"/>
            </div>
            <div v-if="isMarkAsPaidAvailable(invoice)">
              <mark-invoice-as-paid-form :invoice="invoice"/>
            </div>
          </v-menu>
        </v-flex>
      </v-layout>
    </template>
  </with-invoice>
</template>

<script>
  import MarkInvoiceAsDraftForm from './status/MarkInvoiceAsDraftForm'
  import MarkInvoiceAsCheckedForm from './status/MarkInvoiceAsCheckedForm'
  import MarkInvoiceAsChargedForm from './status/MarkInvoiceAsChargedForm'
  import MarkInvoiceAsPaidForm from './status/MarkInvoiceAsPaidForm'
  import {InvoiceStatus, isInvoiceStatusChangeAvailable} from "../../../services/invoice";
  import WithInvoice from "./WithInvoice";

  export default {
    name: 'change-invoice-status',
    components: {
      WithInvoice,
      MarkInvoiceAsDraftForm,
      MarkInvoiceAsCheckedForm,
      MarkInvoiceAsChargedForm,
      MarkInvoiceAsPaidForm
    },
    props: {
      invoiceId: {
        type: Number,
        required: true,
      }
    },
    data() {
      return {
        changeFormsVisible: false
      }
    },
    methods: {
      isMarkAsDraftAvailable(invoice) {
        return isInvoiceStatusChangeAvailable(invoice.status, InvoiceStatus.Draft)
      },
      isMarkAsCheckedAvailable(invoice) {
        return isInvoiceStatusChangeAvailable(invoice.status, InvoiceStatus.Checked)
      },
      isMarkAsChargedAvailable(invoice) {
        return isInvoiceStatusChangeAvailable(invoice.status, InvoiceStatus.Charged)
      },
      isMarkAsPaidAvailable(invoice) {
        return isInvoiceStatusChangeAvailable(invoice.status, InvoiceStatus.Paid)
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/ChangeInvoiceStatus.vue